/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MetricOverviewResponse } from "../models/http/data-centers/data-centers-metric-overview-response.model";
import { SiteMetric } from "../models/http/data-centers/data-centers-site-metric.model";
import { SiteSerie } from "../models/http/data-centers/data-centers-site-serie.model";
import { DashboardDataCentersHttpService } from "./http/dashboard-data-centers-http.service";

@Injectable({
	providedIn: "root"
})
export class DashboardDataCentersService {
	constructor(private _dashboardDataCentersHttpService: DashboardDataCentersHttpService) {}

	public getUserSiteList(): Observable<SiteSerie> {
		return this._dashboardDataCentersHttpService.getUserSiteList();
	}

	public getMetricOverview(): Observable<MetricOverviewResponse> {
		return this._dashboardDataCentersHttpService.getMetricOverview();
	}

	public getUserSiteMetricData(siteId: number): Observable<SiteMetric[]> {
		return this._dashboardDataCentersHttpService.getUserSiteMetricData(siteId);
	}
}
